import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import FormSelect from "../../../components/formSelect";
import { createPushNotification } from "../../../api/endpoint";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../../../components/loader";
import toast from "react-hot-toast";

const EditModal = ({ isEditOpen, closeEditModal, id, fetchData }) => {
  const [pushNotification, setPushNotification] = useState({
    notificationType: "",
    userPlan: "",
    title: "",
    text: "",
    triggerTime: "",
  });
  const { notifications } = useSelector((state) => state.notifications);

  useEffect(() => {
    const selectedNotification = notifications?.find(
      (notif) => notif?.id == id
    );
    const formData = {
      notificationType: selectedNotification?.notificationType,
      userPlan: selectedNotification?.userPlan,
      title: selectedNotification?.title,
      text: selectedNotification?.text,
      triggerTime: selectedNotification?.triggerTime
    };
    setPushNotification(formData);
  }, [id]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const validateForm = () => {
    let newErrors = {};

    if (!pushNotification.notificationType)
      newErrors.notificationType = "Notification Type is required.";
    if (!pushNotification.userPlan)
      newErrors.userPlan = "User Plan is required.";
    if (!pushNotification.title.trim()) newErrors.title = "Title is required.";
    if (!pushNotification.text.trim()) newErrors.text = "Text is required.";
    if (!pushNotification.triggerTime)
      newErrors.triggerTime = "Date and Time are required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatToUTC = (date) => {
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const updateAlert = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      const timeInUTC = formatToUTC(new Date(pushNotification.triggerTime));
      const payload = {
        ...pushNotification,
        triggerTime: timeInUTC,
      };
      const response = await axios.post(createPushNotification, payload, {
        params: { id: id },
        headers: { Authorization: `Bearer ${auth}` },
      });
      toast.success('Edit push notification successful')
      closeEditModal();
      fetchData()
    } catch (error) {
      console.error("Error updating push notification", error);
      if (error?.response?.data?.error_description && error?.response?.data?.user_description) {
        toast.error(`${error?.response?.data?.error_description}: ${error?.response?.data?.user_description}`)
      } else {
        toast.error('Error updating push notification')
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={isEditOpen} onHide={closeEditModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Push Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row mb-3">
              <div className="col-md-6">
                <FormSelect
                  label="Notification Type"
                  value={pushNotification.notificationType}
                  onChange={(e) =>
                    setPushNotification({
                      ...pushNotification,
                      notificationType: e.target.value,
                    })
                  }
                  options={[
                    { label: "Select", value: "" },
                    { label: "Feature Update", value: "feature-update" },
                    { label: "New Subscriber", value: "new-subscriber" },
                    { label: "Discount", value: "discount" },
                    { label: "Event", value: "event" },
                  ]}
                />
                {errors.notificationType && (
                  <small className="text-danger">
                    {errors.notificationType}
                  </small>
                )}
              </div>
              <div className="col-md-6">
                <FormSelect
                  label="User Type"
                  value={pushNotification.userPlan}
                  onChange={(e) =>
                    setPushNotification({
                      ...pushNotification,
                      userPlan: e.target.value,
                    })
                  }
                  options={[
                    { label: "Select", value: "" },
                    { label: "All", value: "ALL" },
                    { label: "Monthly", value: "MONTHLY" },
                    { label: "Yearly", value: "YEARLY" },
                    { label: "Free User", value: "FREEUSER" },
                  ]}
                />
                {errors.userPlan && (
                  <small className="text-danger">{errors.userPlan}</small>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <Input
                  label="Date and Time"
                  type="datetime-local"
                  value={pushNotification.triggerTime}
                  onChange={(e) =>
                    setPushNotification({
                      ...pushNotification,
                      triggerTime: e.target.value,
                    })
                  }
                />
                {errors.triggerTime && (
                  <small className="text-danger">{errors.triggerTime}</small>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <Input
                  label="Title"
                  type="text"
                  placeholder="Title"
                  value={pushNotification.title}
                  onChange={(e) =>
                    setPushNotification({
                      ...pushNotification,
                      title: e.target.value,
                    })
                  }
                />
                {errors.title && (
                  <small className="text-danger">{errors.title}</small>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <Input
                  label="Text"
                  type="text"
                  placeholder="Text"
                  value={pushNotification.text}
                  onChange={(e) =>
                    setPushNotification({
                      ...pushNotification,
                      text: e.target.value,
                    })
                  }
                />
                {errors.text && (
                  <small className="text-danger">{errors.text}</small>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button text="Save Changes" callBack={updateAlert} />
        </Modal.Footer>
      </Modal>
      {loading && <Loader />}
    </>
  );
};

export default EditModal;
